module.exports = __webpack_public_path__ + "img/36810-025.ecfa56a4.jpg";